'use client'

import Image from 'next/image'
import type { Color } from '@/lib/types'

interface ColorSamplePreviewProps {
  selectedColor: Color | null
}

export default function ColorSamplePreview({ selectedColor }: ColorSamplePreviewProps) {
  if (!selectedColor) {
    return null
  }

  const imageUrl = selectedColor.image_path
    ? `${process.env.NEXT_PUBLIC_SUPABASE_URL}/storage/v1/object/public/color-images/${selectedColor.image_path}`
    : null

  if (!imageUrl) {
    return null
  }

  return (
    <div className="mt-6 bg-white rounded-3xl shadow-soft p-6">
      <div className="mb-3">
        <h3 className="text-sm font-medium text-gray-700">Selected Color Sample</h3>
        <p className="text-xs text-gray-500 mt-1">{selectedColor.name}</p>
      </div>
      <div className="relative w-full aspect-square rounded-2xl overflow-hidden bg-gray-50">
        <Image
          src={imageUrl}
          alt={`${selectedColor.name} filament sample`}
          fill
          className="object-cover"
          sizes="(max-width: 768px) 100vw, 50vw"
          priority={false}
        />
      </div>
      <p className="text-xs text-gray-400 mt-3 text-center italic">
        Actual color may vary slightly from sample
      </p>
    </div>
  )
}
